import { ApiParameter, get } from "@insite/client-framework/Services/ApiService"
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface InventoryPuddlesParams extends ApiParameter {
    productId: string;
    postalCode: string;
    IsLbIndicator : string;
    IsLBInonSplOrd :string;
}

export interface WarehousePuddleModal extends BaseModel{
    national: number;
    regional: number;
    lbProductCount:number;
    regionalHubName: string;
    regionalHubDC: string;
    ringPuddle: Puddle[];
    hubs: Puddle[];
    branches: Puddle[];
    web: any;
    inventoryLocationQty?: Puddle[];
    deliveryDate: string;
    intransitDays: string;
    returnCode: string;
    returnMessage: string;
  }
  
  export interface Puddle {
    locationDC?: string;// added this variable ---- P21 Change
    location: string;
    qty: number;
    rownum: number;
  }
  
  const getInventoryPuddlesUrl = "/api/v1/getinventorypuddles"
  
  export function getInventoryPuddles(parameter: InventoryPuddlesParams):Promise<WarehousePuddleModal> {
    return get<WarehousePuddleModal>(`${getInventoryPuddlesUrl}/`, parameter);
  }